import React from 'react';
import styled from 'styled-components';
const StyledEllipsis = styled.span`
  display: inline-flex;
  text-align: center;
  align-items: center;
  padding: 0 8px;
`;
export default function renderEllipsis({
  key
}) {
  return /*#__PURE__*/React.createElement(StyledEllipsis, {
    key: key
  }, "...");
}